"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


//////////////////
// WEBPACK FOOTER
// ./~/victory-vendor/lib-vendor/d3-shape/src/descending.js
// module id = ./node_modules/victory-vendor/lib-vendor/d3-shape/src/descending.js
// module chunks = 1